import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { dealSelector } from './selectors';
import { fetchDealIfNeeded } from './thunks';
import { useAppDispatch } from '../../hooks/useAppDispatch';
export var useDeal = function (idOrAlias, onFetchError) {
    var item = useSelector(function (state) {
        return dealSelector(state, idOrAlias);
    });
    var dispatch = useAppDispatch();
    useEffect(function () {
        if (idOrAlias) {
            var fetchPromise = dispatch(fetchDealIfNeeded(idOrAlias));
            if (onFetchError) {
                fetchPromise.catch(onFetchError);
            }
        }
    }, [dispatch, idOrAlias, onFetchError, item === null || item === void 0 ? void 0 : item.didInvalidate]);
    return item === null || item === void 0 ? void 0 : item.deal;
};
